import { useParams } from "react-router-dom"
import { useEffect, useState } from "react";
import { T_User } from "../../../types/user";
import api from "../../../utils/api";
import { useErrorSuccess } from "../../../hooks/useErrorSuccess";
import { Container } from "../../../components/formulario/styled";
import { T_cargo } from "../../Pg/AssociarMembroPg/ListaAlteracaoCargo";


export const useGetUsuarioCargo = (idusuario: string | number) => {
  const { setMensagemError } = useErrorSuccess()
  const [cargo, setCargo] = useState<T_cargo>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getCargo = async () => {
    setIsLoading(true)
    try {
      const req = await api.get('ministerio/cargo/usuario/' + idusuario);
      let res = await req?.data
      setCargo(res);
    } catch (error) {
      setMensagemError(JSON.stringify(error?.response?.data?.mensagem || error?.response?.data, null, 2));
    } finally {
      setIsLoading(false)
    }

  }

  useEffect(() => {
    getCargo()
  }, [])

  return {
    cargo,
    isLoading
  }
}


export const User = () => {

  const { id } = useParams();
  const { setMensagemError } = useErrorSuccess();
  const [historico, setHistorico] = useState<T_User[]>();

  const { cargo } = useGetUsuarioCargo(id)

  const getUsuario = async () => {
    try {
      const get = await api.get('view/historico/' + id);
      const res = get.data;
      setHistorico(res);
      return;
    } catch (error) {
      setMensagemError(JSON.stringify(error?.respose?.data?.mensagem || error?.respose?.data, null, 2))
      return;
    }
  }

  useEffect(() => {
    getUsuario()
  }, [])

  return (
    <>
      <div style={{ display: "flex", flex: 1, padding: 5 }}>
        <Container>
          <div style={{ padding: '8px 6px' , display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <p style={{
            fontWeight: 600, fontSize: 18,
          }}>{historico?.[0]?.nome}</p>
          <p>{cargo?.cargo?.descricao}</p>
          </div>
            <div>
              {
                historico?.map(
                  el => (
                    <div style={{
                      margin: '8px 4px',
                      display: 'flex',
                      background: 'white',
                      boxShadow: '4px 4px 8px rgba(0,0,0,0.2)',
                      flexDirection: 'column',
                      gap: 4,
                      borderRadius: '12px',
                      padding: '8px',
                      border: '1px solid #ccc',
                      maxHeight: 'max-content'
                    }}>
                      <p style={{ fontSize: 14 }}>#{el?.id}</p>
                      <p style={{ fontWeight: 600, fontSize: 16, letterSpacing: 1.1 }}>{el?.descricao}</p>
                      <p style={{ fontSize: 14, letterSpacing: 1.1 }}>{el?.inscricao}</p>
                    </div>
                  )
                )
              }
            </div>
        </Container>
      </div>
    </>
  )
}
